import { useEffect, useMemo, useState } from 'react';
import Select from '@Common/Select';
import { Project, Product } from '@Models/types';
import { useTestCaseContext } from '@Context/TestCaseContext';
import { useAuth } from '@Context/CognitoAuthProvider';
import { testrailAPI } from '@Lib/axios/testrail';

const Projects = () => {
  const {
    projects,
    //selectedGenerated,
    selectedProject,
    fetchProjects,
    setSelectedProject,
  } = useTestCaseContext();
  const [loading, setLoading] = useState(false);

  const { logout } = useAuth();
  const testrail = useMemo(() => testrailAPI(logout), [logout]);

  useEffect(() => {
    if (projects.length === 0) {
      setLoading(true);
      fetchProjects().then(() => setLoading(false));
    }
  }, []);

  const projectOptions = useMemo(() => {
    return projects.map((project) => ({
      label: project.name,
      value: project,
    }));
  }, [projects]);

  const handleProjectChange = (
    selected: { label: string; value: Project } | null
  ) => {
    if (selected) {
      setSelectedProject(selected.value);
    }
  };

  const placeholder = loading
    ? 'Loading Projects'
    : selectedProject
      ? selectedProject.name
      : 'Select TestRail Project';

  const favorites = useMemo(
    () => ({
      enabled: true,
      type: 'project' as const,
      fetch: testrail.getFavProj,
      save: testrail.saveFavProj as (
        items: Product[] | Project[]
      ) => Promise<void>,
      favoriteKey: 'id' as const,
    }),
    [testrail]
  );

  return (
    <div className="flex flex-col gap-y-2">
      <div className="mt-2 flex flex-row items-center text-xl font-bold">
        <label className="text-primary-700">TestRail Projects</label>
      </div>
      <Select
        type="project"
        options={projectOptions}
        onChange={handleProjectChange}
        placeholder={placeholder}
        loading={loading}
        disabled={loading}
        favorites={favorites}
      />
    </div>
  );
};

export default Projects;
